import _classCallCheck from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/inherits";
import "antd-mobile/es/activity-indicator/style";
import _ActivityIndicator from "antd-mobile/es/activity-indicator";
/**
 * @module: 加载组件
 * @author: Teacher Tang
 * @date: 2019-06-04 17:06:22
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './style';

var LoadingComponent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LoadingComponent, _PureComponent);

  function LoadingComponent() {
    _classCallCheck(this, LoadingComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingComponent).apply(this, arguments));
  }

  _createClass(LoadingComponent, [{
    key: "render",
    // <
    //   { dispose?: Function; style?: CSSProperties; desc?: string },
    //   any
    // >
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: "loading-page",
          style: this.props.style
        },
        /*#__PURE__*/
        React.createElement(_ActivityIndicator, {
          size: "large",
          toast: true,
          text: this.props.desc || '正在加载'
        }))
      );
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.dispose && this.props.dispose();
    }
  }]);

  return LoadingComponent;
}(PureComponent);

LoadingComponent.propTypes = {
  style: PropTypes.object,
  desc: PropTypes.string,
  dispose: PropTypes.func
};
export default LoadingComponent;